import Repository from './Repository';

const resource = '/province';

export default {
    getAllNames() {
        return Repository.get(`${resource}`);
    },
    getByPostalCodePrefix(postalcodeprefix) {
        return Repository.get(`${resource}/postalcodeprefix/${postalcodeprefix}`);
    }
}